import React from "react";
import { supplierContentData } from "../../data/supplierContentData";
import ListItem from "../ListItem/ListItem";
import { SupplierContentUnitStyle } from "./SupplierContentUnitStyle";

const SupplierContentUnit = () => {
  return (
    <SupplierContentUnitStyle>
      <ListItem items={supplierContentData} />
    </SupplierContentUnitStyle>
  );
};

export default SupplierContentUnit;
